import { createRouter } from '@tanstack/react-router'

// Import the generated route tree
import { routeTree } from './routeTree.gen'
import { ErrorComponent } from './components/error-component'

// Create a new router instance
export const getRouter = () => {
  const router = createRouter({
    routeTree,
    defaultPreload: 'intent',
    defaultErrorComponent: ({ error, info }) => (
      <ErrorComponent error={error} info={info} />
    ),
  })

  return router
}
